<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="marcas" [selectedItem]="newEditForm.get('marca')" [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="aforo">
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="porcentajeAforo">
    </td>
    <td class="multi-actions">
        <i class="fas fa-handshake" *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Ins')"
            app-click-stop-propagation (click)="designarCultivo(cultivoMarca)" title="{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.title' | translate }}"></i>
        <ng-container *ngIf="editable">
            <i class="far fa-save" [ngClass]="{'disabled': getRolePermission()}" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" [ngClass]="{'disabled': getRolePermission()}" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" *ngIf="this.role === 'Administrador' || this.claims.includes('CULMAR_Upd')" [ngClass]="{'disabled': !campanyaHabilitada}" (click)="edit(cultivoMarca)"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" *ngIf="this.role === 'Administrador' || this.claims.includes('CULMAR_Del')" [ngClass]="{'disabled': !campanyaHabilitada}" app-click-stop-propagation (click)="askDelete(cultivoMarca)"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
<div class="modal" *ngIf="errorAddMarca">
  <div class="modal-content">
    <header>
      <h4>{{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.titulo' | translate}}</h4>
    </header>
    <content>
      <p>{{this.errorMsg}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="closeModal()">{{ 'global.cancelar' | translate }}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="newModalDesignacion">
  <div class="modal-content">
    <header>
      <h4>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.title' | translate }}</h4>
    </header>
    <app-cultivo-designacion [cultivoDesignacion]="cultivoDesignacion" (refresh)="refreshDesignacion($event)"></app-cultivo-designacion>
  </div>
</div>

<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
